import { useCallback, useState } from 'react';
import axios, { AxiosError } from 'axios';

const WHITEPAPER_URL =
  'https://9oghn0itah.execute-api.us-east-1.amazonaws.com/default/downloadWhitepaper';

const WhitepaperFileName = {
  'modern-data-stack': 'Mutt Data Whitepaper: Modern Data Stack.pdf',
  'modern-data-stack-technical-roadmap':
    'Mutt Data Whitepaper: The Modern Data Stack A Technical Roadmap.pdf',
};

export type WhitepaperName = keyof typeof WhitepaperFileName;

export interface DownloadWhitepaperBody {
  email: string;
  firstname: string;
  company: string;
  whitepaper: WhitepaperName;
}

export interface DownloadWhitepaperResponse {
  message: string;
  url: string;
}

const useDownloadWhitepaper = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AxiosError | null>(null);

  const downloadWhitepaper = useCallback((body: DownloadWhitepaperBody) => {
    setLoading(true);
    const promise = axios.request<DownloadWhitepaperResponse>({
      method: 'POST',
      url: WHITEPAPER_URL,
      data: body,
    });
    promise.then(
      () => {
        setLoading(false);
        setError(null);
      },
      (err) => {
        setLoading(false);
        setError(err);
      }
    );
    return promise.then((res) => {
      var link = document.createElement('a');
      link.setAttribute('href', res.data.url);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
      link.setAttribute('download', WhitepaperFileName[body.whitepaper]);
      link.click();
    });
  }, []);

  return [downloadWhitepaper, { loading, error }] as const;
};

export default useDownloadWhitepaper;
